import { clsx } from "clsx";
import React from "react";

export default function IconTick({ className }: { className?: string }) {
  return (
    <svg
      className={clsx("", className)}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="opacity-0 group-has-[:checked]:opacity-100"
        d="M29.1299 6.28125L11.8486 23.5625L4.56738 16.2813L3.12988 17.7187L11.1299 25.7188L11.8486 26.4062L12.5674 25.7188L30.5674 7.71875L29.1299 6.28125Z"
        fill="currentColor"
      />
    </svg>
  );
}
